module.exports = __webpack_public_path__ + "img/24.problem_fluid_taps.fc6e5e98.svg";